import {
  ExtraModel,
  Language,
  Rate,
  RoomBasketModel,
  RoomImageMetadata,
  RoomOccupancy,
  SessionGuests,
  SessionStayPeriod,
} from '@cesare';
export * from './components';

export const DEFAULT_LOCATION = 'root';

export enum QW_ROOM_CODE {
  All = 'ALL',
  Private = 'PRIVATE',
  Bunk = 'DORM',
  BunkF = 'DORMF',
}

export const QW_ROOM_TYPE_LIST = [
  { value: QW_ROOM_CODE.All, label: Language.getTranslation('allRoomTypes') },
  {
    value: QW_ROOM_CODE.Private,
    label: Language.getTranslation('privateRooms'),
  },
  { value: QW_ROOM_CODE.Bunk, label: Language.getTranslation('sharedDorms') },
  {
    value: QW_ROOM_CODE.BunkF,
    label: Language.getTranslation('femaleOnlyDorms'),
  },
];

export interface QwRoomTypeType {
  value: string;
  label: string;
}

export interface QwSessionSettings {
  location?: QwLocation;
  stayPeriod?: SessionStayPeriod;
  guests?: SessionGuests;
  roomType?: QwRoomTypeType;
  hasChildren?: boolean;
}
export interface QwBookingProgress {
  hotelValue?: string;
  isInProgress?: boolean;
  isAccommodationSatisfied?: boolean;
}
export interface QwLocationStorage {
  locationName: string;
  locationValue: string;
  locationHotelId: string;
}
export interface QwLocation {
  value: string;
  hotelId: number;
  engineId: string;
  name: string;
  subtitle?: string;
  link?: string;
  isCurrent?: boolean;
}

export enum QwBookinBarInputType {
  Location = 'qw-location-list',
  Guest = 'qw-guest',
  Date = 'qw-calendar',
  RoomType = 'qw-room-type-list',
}
export enum QwRoomListCardButtonType {
  BookNow = 'bookNow',
  ViewRoom = 'viewRoom',
  ChangeDate = 'changeDate',
  Checkout = 'checkout',
}

export enum QwRoomListType {
  Inline = 'inline',
  Grid = 'grid',
  Card = 'card',
}

export enum QwRoomBasketType {
  Classic = 'classic',
  Basic = 'basic',
}

export enum QwRoomBaseInfoType {
  List = 'list',
  Inline = 'inline',
}

export enum QwRoomBaseInfoGuestType {
  Icon = 'icon',
  Text = 'text',
}

export enum QwRoomListOrderType {
  AscendingPrice = 'ascendingPrice',
  DescendingPrice = 'descendingPrice',
}

export interface QwChangeRoomEvent {
  quantity: string;
  room: RoomBasketModel;
  occupancyId?: RoomOccupancy['occupancyId'];
  rateId?: Rate['rateId'];
}

export interface QwChangeExtraEvent {
  quantity: string;
  extraId: ExtraModel['extraId'];
  roomId?: number;
}

export enum GuestDetailFormProperty {
  FirstName = 'firstName',
  LastName = 'lastName',
  EmailAddress = 'emailAddress',
  PhoneNumber = 'phoneNumber',
  PhoneCountryCode = 'phoneCountryCode',
  Phone = 'phone',
  ConfirmConditions = 'confirmConditions',
  PromoSubscription = 'promoSubscription',
  Title = 'title',
  CountryCode = 'countryCode',
}

export enum QwWeekCalendarDirection {
  Left = 'left',
  Right = 'right',
}

export enum QwCounterId {
  QwRoomRateListCounter = 'qwRoomRateListCounter',
  QwBasketSummaryBasketRoomsCounter = 'qwBasketSummaryBasketRoomsCounter',
  QwBasketSummaryBasketExtrasCounter = 'qwBasketSummaryBasketExtrasCounter',
  QwRoomRateCounter = 'qwRoomRateCounter',
  QwExtraCardCounter = 'qwExtraCardCounter',
  QwGuestCounter = 'qwGuestCounter',
  QwRoomListCardCounter = 'qwRoomListCardCounter',
}

export enum QwOffersOrderType {
  OrderByPrice = 'orderByPrice',
  OrderByRoomType = 'orderByRoomType',
}

export enum QwCurrencyType {
  Classic = 'classic',
  Compact = 'compact',
}

export enum QwLanguageType {
  Select = 'select',
  DropDown = 'dropDown',
}

export enum QwGuestType {
  Adults = 'adults',
  Children = 'children',
  Infants = 'infants',
}

export interface QwApiError {
  body: { Code: string; Message: string };
  error: boolean;
  message: string;
  status: number;
}
export interface QwModalBaseInfo {
  title: string;
  description: string;
  index: number;
  infoType: string;
  isPrivate: boolean;
  roomId: string;
  showCarousel: boolean;
  images: RoomImageMetadata[];
  transformationOptions: object;
  image: string;
  services: any[];
  roomCardBedding: number | string;
  cardSessionHotelId: number | string;
}

export const NEWSLETTERS = {
  url: 'https://widgets.experience-hotel.com/front/widget/widget-newsletter/',
  hossegor: { widgetId: 165, listId: 200 },
  'paris-gentilly': { widgetId: 214, listId: 257 },
  'paris-nation': { widgetId: 216, listId: 259 },
  roma: { widgetId: 310, listId: 378 },
  vienna: { widgetId: 218, listId: 261 },
};

export const NEWSLETTER_COUNTRIES = {
  AF: 1,
  AX: 2,
  AL: 3,
  DZ: 4,
  AS: 5,
  AD: 6,
  AO: 7,
  AI: 8,
  AQ: 9,
  AG: 10,
  AR: 11,
  AM: 12,
  AW: 13,
  AC: 14,
  AU: 15,
  AT: 16,
  AZ: 17,
  BS: 18,
  BH: 19,
  BD: 20,
  BB: 21,
  BY: 22,
  BE: 23,
  BZ: 24,
  BJ: 25,
  BM: 26,
  BT: 27,
  BO: 28,
  BA: 29,
  BW: 30,
  BR: 31,
  IO: 32,
  VG: 33,
  BN: 34,
  BG: 35,
  BF: 36,
  BI: 37,
  KH: 38,
  CM: 39,
  CA: 40,
  IC: 41,
  CV: 42,
  BQ: 43,
  KY: 44,
  CF: 45,
  EA: 46,
  TD: 47,
  CL: 48,
  CN: 49,
  CX: 50,
  CC: 51,
  CO: 52,
  KM: 53,
  CG: 54,
  CD: 55,
  CK: 56,
  CR: 57,
  CI: 58,
  HR: 59,
  CU: 60,
  CW: 61,
  CY: 62,
  CZ: 63,
  DK: 64,
  DG: 65,
  DJ: 66,
  DM: 67,
  DO: 68,
  EC: 69,
  EG: 70,
  SV: 71,
  GQ: 72,
  ER: 73,
  EE: 74,
  ET: 75,
  FK: 76,
  FO: 77,
  FJ: 78,
  FI: 79,
  FR: 80,
  GF: 81,
  PF: 82,
  TF: 83,
  GA: 84,
  GM: 85,
  GE: 86,
  DE: 87,
  GH: 88,
  GI: 89,
  GR: 90,
  GL: 91,
  GD: 92,
  GP: 93,
  GU: 94,
  GT: 95,
  GG: 96,
  GN: 97,
  GW: 98,
  GY: 99,
  HT: 100,
  HN: 101,
  HK: 102,
  HU: 103,
  IS: 104,
  IN: 105,
  ID: 106,
  IR: 107,
  IQ: 108,
  IE: 109,
  IM: 110,
  IL: 111,
  IT: 112,
  JM: 113,
  JP: 114,
  JE: 115,
  JO: 116,
  KZ: 117,
  KE: 118,
  KI: 119,
  XK: 120,
  KW: 121,
  KG: 122,
  LA: 123,
  LV: 124,
  LB: 125,
  LS: 126,
  LR: 127,
  LY: 128,
  LI: 129,
  LT: 130,
  LU: 131,
  MO: 132,
  MK: 133,
  MG: 134,
  MW: 135,
  MY: 136,
  MV: 137,
  ML: 138,
  MT: 139,
  MH: 140,
  MQ: 141,
  MR: 142,
  MU: 143,
  YT: 144,
  MX: 145,
  FM: 146,
  MD: 147,
  MC: 148,
  MN: 149,
  ME: 150,
  MS: 151,
  MA: 152,
  MZ: 153,
  MM: 154,
  NA: 155,
  NR: 156,
  NP: 157,
  NL: 158,
  NC: 159,
  NZ: 160,
  NI: 161,
  NE: 162,
  NG: 163,
  NU: 164,
  NF: 165,
  KP: 166,
  MP: 167,
  NO: 168,
  OM: 169,
  PK: 170,
  PW: 171,
  PS: 172,
  PA: 173,
  PG: 174,
  PY: 175,
  PE: 176,
  PH: 177,
  PN: 178,
  PL: 179,
  PT: 180,
  PR: 181,
  QA: 182,
  RE: 183,
  RO: 184,
  RU: 185,
  RW: 186,
  WS: 187,
  SM: 188,
  ST: 189,
  SA: 190,
  SN: 191,
  RS: 192,
  SC: 193,
  SL: 194,
  SG: 195,
  SX: 196,
  SK: 197,
  SI: 198,
  SB: 199,
  SO: 200,
  ZA: 201,
  GS: 202,
  KR: 203,
  SS: 204,
  ES: 205,
  LK: 206,
  BL: 207,
  SH: 208,
  KN: 209,
  LC: 210,
  MF: 211,
  PM: 212,
  VC: 213,
  SD: 214,
  SR: 215,
  SJ: 216,
  SZ: 217,
  SE: 218,
  CH: 219,
  SY: 220,
  TW: 221,
  TJ: 222,
  TZ: 223,
  TH: 224,
  TL: 225,
  TG: 226,
  TK: 227,
  TO: 228,
  TT: 229,
  TA: 230,
  TN: 231,
  TR: 232,
  TM: 233,
  TC: 234,
  TV: 235,
  UM: 236,
  VI: 237,
  UG: 238,
  UA: 239,
  AE: 240,
  GB: 241,
  US: 242,
  UY: 243,
  UZ: 244,
  VU: 245,
  VA: 246,
  VE: 247,
  VN: 248,
  WF: 249,
  EH: 250,
  YE: 251,
  ZM: 252,
  ZW: 253,
};
export const NEWSLETTER_LANGUAGES = {
  en: 2,
  fr: 1,
  de: 22,
  it: 12,
  'pt-br': 3,
  es: 32,
  hu: 102,
};

export const LOCATIONS = {
  hostel: [
    {
      is_disabled: false,
      name: 'Choose destination',
      value: 'root',
      has_chatbot: true,
      hotel_id: '0',
      engine_id: '0',
      icon: false,
      is_current: false,
    },
    {
      is_disabled: false,
      name: 'Hossegor',
      value: 'hossegor',
      has_chatbot: true,
      hotel_id: '20834',
      engine_id: '2XZF',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2023/02/hossegor-menu.png',
      is_current: false,
    },
    {
      is_disabled: false,
      name: 'Paris Gentilly',
      value: 'paris-gentilly',
      has_chatbot: true,
      hotel_id: '21183',
      engine_id: 'JJYX',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2023/02/paris.png',
      is_current: true,
    },
    {
      is_disabled: false,
      name: 'Paris Nation',
      value: 'paris-nation',
      has_chatbot: true,
      hotel_id: '23578',
      engine_id: 'JJYX',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2023/02/Paris-nation.png',
      is_current: false,
    },
    {
      is_disabled: false,
      name: 'Rio de Janeiro',
      value: 'rio',
      has_chatbot: false,
      hotel_id: '26557',
      engine_id: 'JIU4',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2023/02/Rio.png',
      is_current: false,
    },
    {
      is_disabled: false,
      name: 'Roma',
      value: 'roma',
      has_chatbot: true,
      hotel_id: '28104',
      engine_id: 'JKP7',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2023/03/romA.png',
      is_current: false,
    },
    {
      is_disabled: false,
      name: 'Vienna',
      value: 'vienna',
      has_chatbot: true,
      hotel_id: '25272',
      engine_id: 'JRV2',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2023/02/Vienna.png',
      is_current: false,
    },
    {
      is_disabled: false,
      name: 'Budapest',
      value: 'budapest',
      has_chatbot: true,
      hotel_id: '30200',
      engine_id: 'JTVV',
      icon: 'https://www.joandjoe.com/paris-gentilly/wp-content/uploads/2024/12/hungarian-parlement-1.png',
      is_current: false,
    },
  ],
};

console.log('version 2.1.9');
